<template>
    <div class="tooltip" ref="tooltip">
        <img class="tooltip-img" src="/images/tooltip_inactive.png" @click="openToolTip">

        <div
            class="tooltip-block"
            v-if="showToolTip"
            v-click-outside-component="closeToolTip">
            <i class="uk-close" @click="closeToolTip"></i>
            <div v-if="indexData" class="tooltip-block-content">
                <div class="tooltip-block-title blue-red-hover-text">
                    <card-link v-if="indexData.ogrn" :ogrn="indexData.ogrn">{{indexData.name_short || indexData.name_full}}</card-link>
                    <template v-else>
                        <template v-if="indexData.name_short">{{indexData.name_short}}</template>
                        <template v-else>{{indexData.name_full}}</template>
                    </template>
                </div>
                <div class="tooltip-block-ogrn-inn">
                    <b>ИНН</b>: {{indexData.inn}} <b>ОГРН</b>: {{indexData.ogrn}}
                </div>

                <div class="tooltip-block-date">
                    <template v-if="indexData.date_stop">
                        <i style="color: #e74c3c; cursor: help;" title="Ликвидированно" class="uk-icon-times-circle"></i>
                        <template> ликвидированно: {{new Date(indexData.date_stop).toLocaleDateString()}}</template>
                    </template>
                    <template v-else>
                        <i style="color: #2ecc71; cursor: help;" title="Действующее" class="uk-icon-check-circle"></i>
                        <template> зарегистрировано: {{new Date(indexData.date_start).toLocaleDateString()}}</template>
                    </template>
                </div>
                <div class="tooltip-block-address" v-if="indexData.addr_full">
                    <b>Адрес:</b> {{indexData.addr_full}}
                </div>
                <div class="tooltip-block-upr" v-if="indexData.upr[0] && indexData.upr.length && indexData.upr[0].position">
                    <b>{{lowerButFirst(indexData.upr[0].position)}}:</b>
                    <template v-if="indexData.upr[0].inn">
                        <person-afil :inn="indexData.upr[0].inn" :fio="indexData.upr[0].name">{{onlyFirstLetterBig(indexData.upr[0].name) + ` (ИНН ${indexData.upr[0].inn})`}}</person-afil>
                    </template>
                    <template v-else>{{ indexData.upr[0].name }}</template>
                </div>
                <div class="tooltip-block-uchr" >
                    <b>Собственники: </b>
                    <template v-if="indexData.uchr && indexData.uchr.length">
                        <span class="stay-on-this-row" v-for="(e, i) in indexData.uchr" :key="i">
                            <card-link class="tooltip-link" v-if="e.ogrn || (String(e.inn).length === 10)" :ogrn="e.ogrn || e.inn">{{ e.name }}<span v-if="e.inn">{{ ` (ИНН ${e.inn})` }}</span></card-link>
                            <person-afil class="stay-on-this-row" v-else-if="e.inn && String(e.inn).length !== 10" :inn="e.inn" :fio="e.name">{{onlyFirstLetterBig(e.name) + ` (ИНН ${e.inn})`}}</person-afil>
                            <span class="stay-on-this-row" v-else>{{e.name}}<span v-if="e.inn">{{ ` (ИНН ${e.inn})` }}</span></span>
                            <template v-if="i != indexData.uchr.length - 1"><span class="stay-on-this-row">, </span></template>
                        </span>
                    </template>
                    <template v-else>-</template>
                </div>
                <div class="tooltip-block-okved" v-if="indexData.okved_title">
                    <b>ОКВЭД:</b> {{indexData.okved_title}}
                </div>
                <div class="tooltip-block-capital" v-if="indexData.auth_capital">
                    <b>Уставный капитал:</b> {{moneyFormat(indexData.auth_capital)}} <i class="uk-icon-rub"></i>
                </div>
                <div class="tooltip-block-viruchka" v-if="indexData.fin_years && indexData.fin_years.length && indexData.viruchka">
                    <b>Выручка за {{indexData.fin_years[indexData.fin_years.length - 1]}} год:</b>
                    <template>{{moneyFormat(indexData.viruchka)}}</template>
                </div>
            </div>
            <div v-else></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import personAfil from '@/components/ui/person-afil/personAfil.vue'
import cardLink from '@/components/ui/cardLink.vue'

export default {
    name: 'tooltip',
    props: ["ogrn"],
    data() {
        return {
            showToolTip: false,
            indexData: null
        }
    },
    components: {
        personAfil,
        cardLink
    },
    methods: {
        closeToolTip(){ this.showToolTip = false },
        openToolTip() {
            this.getCompanyIndexData()
            this.showToolTip = true
        },
        getCompanyIndexData() {
            if(!this.indexData) {
                axios({
                    method: 'get',
                    url: window.api_pro + "company/" + this.$props.ogrn + "/index",
                    headers: {
                        "Authorization": `Bearer ${window.apiSession}`
                    }
                }).then(e => {
                    if(e.data.status.code == 200) {
                        this.indexData = e.data.data
                    }
                })
            }
        },
        onlyFirstLetterBig(name) {
            if(name) {
                const fio = name.split(' ').map(n => this.capitalize(n.toLowerCase()))
                return fio.join(' ')
            } else {
                return '-'
            }
            
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/tooltip"
.tooltip
    overflow: visible !important
.tooltip-link
    display: inline
.tooltip-block-ogrn-inn,
.tooltip-block-date
    font-style: italic
.affil-linker
    display: inline    
.stay-on-this-row
    display: inline 
.person-affil
    display: inline    

</style>